import React from 'react';
import { useIntl } from 'react-intl';
import { Alert } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import { useUserTokenDecoded } from '../../../redux/slices/appInfo/hooks';

/**
 * Design product-gaps c2: the access request reached support@music24.com. Support answers by
 * email, at the address the artist signs in with. A repeat request inside a day reads the same;
 * the server sends no second email.
 */
const ConnectRequestSentComponent: React.FC = () => {
  const intl = useIntl();
  const email = useUserTokenDecoded()?.email;

  return (
    <Alert color="success" className="mb-0">
      <strong className="d-block">
        {intl.formatMessage({
          id: 'app.sml.catalog.connect.requestSent',
          defaultMessage: 'We got your request and will email you.',
        })}
      </strong>
      {email !== undefined && email !== ''
        ? intl.formatMessage(
            {
              id: 'app.sml.catalog.connect.requestSentTo',
              defaultMessage: 'Our support team answers at your sign-in address, {email}.',
            },
            { email }
          )
        : null}
    </Alert>
  );
};

export const ConnectRequestSent = TypedMemo(ConnectRequestSentComponent);
